/**
 * Copy of the `bikini2026` templates, the same as on the coded pages
 * (`modules/v2/Bikini2026Landing`, `modules/v2/Bikini/funnel`). Shared by the templates and
 * the defaults of a newly added section.
 */

/** Top transformations of the Hollywood landing (`topTransformationsHero`). */
const heroTransformationIds = ["45", "43", "34", "46", "31", "47", "54", "36", "51", "30"];

export const bikini2026HeaderProps = { ctaLabel: "Dołączam", hidden: true };

export const bikini2026HeroProps = {
  badge: "Ponad 10 000 kobiet ukończyło wyzwanie",
  title: "<strong>6 tygodni</strong> do <em>bikini</em>.<br />W domu, bez siłowni.",
  subtitle:
    "Wyzwanie online dla kobiet, które chcą szybko zgubić do 10 kg. Trening 45 minut co drugi dzień, prosta dieta i aplikacja, która prowadzi Cię dzień po dniu.",
  bullets: [
    "Bez siłowni i bez liczenia kalorii",
    "Dieta mięsna albo bezmięsna, z produktów z każdego sklepu",
    "Schudnij 5 kg i odbierz 300% dofinansowania",
  ],
  savingsBadge: "Teraz {{procentRabatu}}% taniej",
  ctaLabel: "Dołączam do wyzwania",
  ctaPriceNote: "dostęp od razu",
  trust: [
    { icon: "👭", boldText: "10 000+", rest: "uczestniczek" },
    { icon: "📱", boldText: "Aplikacja", rest: "zamiast plików PDF" },
    { icon: "⚡", boldText: "Dostęp", rest: "od razu po zakupie" },
  ],
};

export const bikini2026TransformationsProps = { transformationIds: heroTransformationIds };

export const bikini2026PainProps = {
  eyebrow: "Znasz to?",
  title: "To nie Ty zawodzisz. <strong>Zawodzi plan.</strong>",
  text: "Wyzwanie 6 Tygodni do Bikini to prosty plan, który daje wszystko, czego potrzebujesz, żeby zbudować trwałe nawyki, zredukować oporny tłuszcz i wysmuklić mięśnie. Bez monotonnej diety i bez efektu jojo.",
  points: [
    "Trenujesz, a waga stoi w miejscu",
    "Dieta jest tak monotonna, że po tygodniu masz dość",
    "Wydałaś już sporo na tabletki i szejki, które nic nie dały",
    "Nie masz czasu trenować codziennie",
    "Po każdej diecie wraca efekt jojo",
  ],
};

export const bikini2026IncludedItems = [
  {
    icon: "🍑",
    title: "Nogi, pośladki, brzuch",
    text: "Treningi ukierunkowane na sylwetkę plażową. Podniesiesz pośladki, zarysujesz talię i wysmuklisz ramiona bez godzin cardio.",
  },
  {
    icon: "⏱️",
    title: "45 minut co drugi dzień",
    text: "Treningi hybrydowe, które spalają tłuszcz jeszcze kilka godzin po zakończeniu. W domu albo na siłowni.",
  },
  {
    icon: "🥗",
    title: "Najprostsza dieta na świecie",
    text: "Do przygotowania w 20 minut dziennie. Mięsna albo bezmięsna, bez egzotycznych produktów.",
  },
  {
    icon: "🍫",
    title: "Bez głodu i napadów na słodkie",
    text: "Odwrotne ładowanie węglowodanami sprawia, że nie musisz rezygnować ze słodyczy, czekolady czy prosecco.",
  },
  {
    icon: "⏳",
    title: "Sylwetka klepsydry",
    text: "Plan zbudowany pod proporcje: wąska talia, zaokrąglone pośladki, smukłe ramiona.",
  },
  {
    icon: "🎥",
    title: "Nauka techniki",
    text: "Każde ćwiczenie z profesjonalną demonstracją wideo, więc wiesz, że robisz je dobrze.",
  },
  {
    icon: "😴",
    title: "Sen i suplementy",
    text: "Dowiesz się, jak wydłużyć sen głęboki i które tanie suplementy naprawdę przyspieszają efekty.",
  },
  {
    icon: "👭",
    title: "Prywatna grupa",
    text: "Tysiące kobiet z tym samym celem, wsparcie uczestniczek i ekspertów od żywienia i treningu.",
  },
];

export const bikini2026IncludedProps = {
  eyebrow: "Co dostajesz",
  title: "Wszystko w <strong>jednej aplikacji</strong>",
  items: bikini2026IncludedItems,
};

export const bikini2026TimelineProps = {
  eyebrow: "Jak to wygląda",
  title: "Twoje <strong>6 tygodni</strong>",
  steps: [
    {
      week: "Dzień 1",
      title: "Dostajesz dostęp do aplikacji",
      text: "Od razu po zakupie widzisz plan treningów, dietę i listę zakupów na pierwszy tydzień.",
    },
    {
      week: "Tydzień 1-2",
      title: "Uczysz się techniki i nowego jedzenia",
      text: "Pierwsze treningi z demonstracją wideo, proste posiłki i koniec z głodem wieczorem.",
    },
    {
      week: "Tydzień 3-4",
      title: "Widzisz pierwsze efekty",
      text: "Spadają centymetry w talii, ubrania leżą luźniej, wraca energia na cały dzień.",
    },
    {
      week: "Tydzień 5-6",
      title: "Domykasz metamorfozę",
      text: "Mocniejsze treningi pod nogi, pośladki i brzuch. Na koniec odbierasz nagrodę za wynik.",
    },
  ],
};

export const bikini2026RewardProps = {
  eyebrow: "Nagroda za Twój wynik",
  title: "Osiągnij efekt, a <strong>oddamy Ci 300%</strong>",
  text: "Jedyne w Polsce wyzwanie z gwarancją rezultatów. Schudnij 5 kg albo wykonaj 90% treningów, a dostaniesz 300% dofinansowania do dalszej metamorfozy w Programie Budowy Sylwetki Hollywood.",
  rewardMultiplier: 3,
  items: [
    {
      icon: "⚖️",
      text: "<strong>-5 kg</strong> albo <strong>90% treningów</strong> w 6 tygodni",
      textWithoutPrice: "",
    },
    {
      icon: "🎁",
      text: "Odbierasz <strong>{{nagroda}}</strong> na Program Hollywood",
      textWithoutPrice: "Odbierasz <strong>300% dofinansowania</strong> na Program Hollywood",
    },
    { icon: "📱", text: "Postęp widzisz na bieżąco w aplikacji", textWithoutPrice: "" },
  ],
};

export const bikini2026MetamorphosesProps = {
  eyebrow: "Metamorfozy",
  title: "One też <strong>zaczynały od zera</strong>",
  text: "Posłuchaj, jak wyglądała droga kobiet, które zmieniły sylwetkę z Programem Hollywood:",
  /** First six of `allWithVideo`. */
  transformationIds: ["45", "43", "34", "46", "31", "47"],
};

export const bikini2026OfferProps = {
  title: "Zacznij dziś i za 6 tygodni <strong>załóż bikini bez kompleksów</strong>",
  benefits: [
    "Do <strong>-10 kg</strong> i <strong>-15 cm</strong> w talii",
    "Plan treningów i diety <strong>dzień po dniu</strong>",
    "<strong>300% dofinansowania</strong> za wynik",
  ],
  eyebrow: "Program Hollywood",
  productName: "Wyzwanie 6 Tygodni do Bikini",
  regularPriceLabel: "Cena regularna",
  savingsLabel: "Oszczędzasz {{oszczednosc}} (-{{procentRabatu}}%)",
  currentPriceLabel: "Cena teraz",
  priceLabel: "Twoja inwestycja",
  installmentsLabel: "lub <strong>{{raty}}</strong>",
  ctaLabel: "Tak, dołączam do wyzwania",
  ctaNote: "⚡ Dostęp do aplikacji od razu po zakupie",
  footnotes: ["🎁 300% dofinansowania za wynik", "🔒 Bezpieczna płatność"],
  href: "",
};

export const bikini2026FaqProps = {
  eyebrow: "Najczęstsze pytania",
  title: "Zanim się <strong>zapiszesz</strong>",
  items: [
    {
      q: "Jakie efekty mogę osiągnąć w 6 tygodni?",
      a: "W 6 tygodni możesz stracić od 3 do 8 kg, zmniejszyć obwód talii o 5 do 15 cm i wyraźnie poprawić kondycję. Efekty zależą od Twojego zaangażowania i trzymania się planu.",
    },
    {
      q: "Czy naprawdę mogę odebrać 300% dofinansowania?",
      a: "Tak. Jeżeli schudniesz 5 kg albo wykonasz 90% treningów, dostaniesz od nas trzy razy tyle, ile zapłaciłaś za wyzwanie, na dalszą metamorfozę w Programie Budowy Sylwetki Hollywood.",
    },
    {
      q: "Czy znajdę czas na dietę i trening?",
      a: "Treningi trwają 45 minut co drugi dzień, a posiłki przygotujesz w około 20 minut dziennie. Program powstał z myślą o zapracowanych kobietach, także mamach.",
    },
    {
      q: "Czy muszę chodzić na siłownię?",
      a: "Nie. Wszystkie treningi zrobisz w domu. Jeśli wolisz siłownię, możesz trenować tam według tego samego planu.",
    },
    {
      q: "Czy będę miała wsparcie?",
      a: "Tak. Dostajesz dostęp do prywatnej grupy, w której wspierają się uczestniczki i odpowiadają eksperci od żywienia i treningu.",
    },
    {
      q: "Kiedy dostanę dostęp?",
      a: "Od razu po opłaceniu zamówienia. Na Twój e-mail przyjdą dane do logowania w aplikacji.",
    },
  ],
};

export const bikini2026FooterProps = {
  metamorphosesCount: "Ponad 18,000 metamorfoz",
  copyright: "© 2026 Program Hollywood. Wszystkie prawa zastrzeżone",
};

export const bikini2026StickyCtaProps = {
  productLabel: "6 Tygodni do Bikini",
  noteWithDiscount: "Zamiast {{cenaPrzedRabatem}}",
  note: "⚡ Dostęp od razu",
  ctaLabel: "Dołączam",
};

export const bikini2026CheckoutProps = {
  seoTitle: "6 Tygodni do Bikini - płatność | Program Hollywood",
  heroTitle: "Dołączasz do wyzwania <strong>6 Tygodni do Bikini</strong>",
  heroSubtitle: "Trening 45 minut co drugi dzień, prosta dieta i aplikacja. Dostęp od razu po płatności.",
  productIcon: "👙",
  productName: "6 Tygodni do Bikini",
  productTagline: "Treningi w domu, prosta dieta i aplikacja. 300% dofinansowania za wynik.",
  productItems: bikini2026IncludedItems.map((item) => item.title),
  frameText:
    "🎁 <strong>300% dofinansowania.</strong> Schudnij 5 kg albo wykonaj 90% treningów, a dostaniesz trzy razy tyle, ile zapłacisz, na dalszą metamorfozę.",
  frameDetails:
    "Warunek: w ciągu 6 tygodni schudniesz 5 kg albo wykonasz 90% treningów z planu. Wtedy dostajesz trzy razy tyle, ile zapłaciłaś za wyzwanie, do wykorzystania na dalszą metamorfozę w Programie Budowy Sylwetki Hollywood.",
  phoneHelpText: "Tylko w sprawie Twojego zamówienia. Nie dzwonimy z reklamami.",
  afterPaymentSteps: [
    { when: "Za 2 minuty", what: "E-mail z dostępem do aplikacji." },
    { when: "Dziś, 5 minut", what: "Krótka ankieta w aplikacji, żeby dopasować plan do Ciebie." },
    { when: "Od jutra", what: "Pierwszy trening i jadłospis na pierwszy tydzień." },
  ],
  faq: [
    {
      q: "Czy coś mi się samo przedłuży?",
      a: "Nie. Płacisz za 6 tygodni wyzwania.",
      installmentsNote: "Przy ratach pobieramy tylko kolejne raty po {{rata}}.",
    },
    {
      q: "Czy muszę chodzić na siłownię?",
      a: "Nie. Wszystkie treningi zrobisz w domu, 45 minut co drugi dzień. Jeśli wolisz siłownię, plan działa i tam.",
      installmentsNote: "",
    },
    {
      q: "Kiedy dostanę dostęp?",
      a: "Od razu po opłaceniu zamówienia. Dane do logowania w aplikacji przyjdą na Twój e-mail.",
      installmentsNote: "",
    },
  ],
  stickyLabel: "6 Tygodni do Bikini",
  payButtonLabel: "Zapłać {{kwota}} i zacznij wyzwanie",
  payButtonNote: "Dostęp do aplikacji od razu po płatności",
};

export const bikiniFunnelCheckoutProps = {
  heroTitle: "<em>Gratulacje! </em>Zaraz rozpoczniemy ostateczną metamorfozę Twojej sylwetki!",
  heroSubtitle: "Dokonaj bezpiecznej płatności",
  participantsBadge: "Ponad 12,000 uczestniczek",
  rewardBadge: "Wygraj dofinansowanie do dalszej metamorfozy!",
  ctaText: "Zaczynam metamorfozę -",
  priceDescription: "🥪 Prosta dieta<br/>😍 Treningi modelujące sylwetkę<br/>⚡️ Natychmiastowy dostęp do aplikacji",
  securityItems: [
    { icon: "✅", text: "Gwarancja bezpiecznej płatności online" },
    { icon: "🔒", text: "Twoje dane są chronione certyfikatem SSL" },
    { icon: "💳", text: "Płatność jednorazowa, bez odnawiania" },
  ],
  benefitsTitle: "Ten program<em> jest dla Ciebie, jeśli…</em>",
  benefits: [
    "🥗 Nie chcesz rezygnować z ulubionych smaków, a jednocześnie chcesz chudnąć",
    "🏋️‍♂️ Nie masz czasu (ani ochoty!) na długie, męczące treningi",
    "💊 Masz dość wydawania setek złotych na suplementy, które nic nie dają",
    "⚖️ Nie chcesz spędzać połowy dnia w kuchni na liczeniu kalorii",
    "👩🏻‍💻 Szukasz prostego, skutecznego systemu, który działa nawet przy zapracowanym trybie życia",
    '🍑 Marzysz o kobiecej, zgrabnej sylwetce - bez „pakowania mięśni"',
  ],
  stickyCta: "experiment",
  stickyProductLabel: "6 tygodni do Bikini",
  stickyCtaText: "Zaczynam metamorfozę",
};

export const bikiniFunnelThankYouProps = {
  titleHighlight: "Gratulacje!",
  title: "Twoja metamorfoza właśnie się zaczyna!",
  subtitle: "Wyzwanie <strong>6 Tygodni do Bikini</strong> właśnie się rozpoczyna! Oto Twoje kolejne kroki:",
  steps: [
    {
      icon: "mail",
      text: "Otrzymasz zaproszenie na swój adres email z adresu <strong><u>hello@program-hollywood.pl</u></strong>",
    },
    { icon: "smartphone", text: "Ściągnij aplikację <strong>SylwetkaPro</strong> i załóż konto" },
    { icon: "users", text: "Dołącz do naszej grupy na Facebooku: <strong>6 Tygodni Do Bikini</strong>" },
  ],
  contact:
    "W razie dodatkowych pytań, problemów - skontaktuj się z nami: <strong><u>kontakt@programhollywood.pl</u></strong>",
  confetti: true,
};
